/**
 * Discount Administration Tool
 */
import Table from '../../components/table/Table';
import Routes from '../../helpers/Routes';
import DropDown from '../../components/dropdown/DropDown';
import DiscountToolRepository from '../../repositories/DiscountToolRepository';
import eventListenerProps from './json/eventListenerProps.json';
import tableProps from './json/tableProps.json';
import DiscountToolService from './DiscountToolService';

export default class DiscountTool {
    /**
     * @property {Object} DiscountToolService Save data methods
     * @property {Object} Table helper class
     * @property {Object} Routes helper class
     * @property {Object} DiscountToolRepository repository class
     * @property {Object} eventListenerProps json object with properties
     * @property {Object} tableProps json object with properties
     * @returns void
     */
    constructor() {
        if (document.getElementsByClassName('discount-tool').length < 1) return;

        this.table = new Table();
        this.routes = new Routes();
        this.repository = new DiscountToolRepository();
        this.service = new DiscountToolService();
        this.eventProps = eventListenerProps;
        this.tableProps = tableProps;

        this.initDropDowns();
        this.cellObserver();
    }

    /**
     * @description Initialize Drop downs
     * @returns void
     */
    initDropDowns() {
        new DropDown({
            table: this.table,
            tableProps: this.tableProps,
            routes: this.routes,
            repository: this.repository,
            eventProps: this.eventProps.dropdown,
            tableId: 'discountToolTable',
            initElement: 'productType',
        });
    }

    /**
     * @description Mutation observer for save icons
     * Waiting for user interaction and css classes to be set
     * Adding event listerners to cell icons
     * @returns void
     */
    cellObserver() {
        const observer = new MutationObserver((mutationList, observer) => {
            mutationList.forEach((mutation) => {
                if (mutation.attributeName === 'status') {
                    if (
                        document.querySelector('#discountToolTable').getAttribute('status') ===
                        'true'
                    ) {
                        for (let item of document.querySelectorAll('.saveInput')) {
                            this.service.addSaveEventListener(item);
                        }
                    }
                }
            });
        });

        observer.observe(
            document.querySelector('#discountToolTable'),
            {
                attributeFilter: ['status'],
                characterData: false,
                attributes: true,
                childList: false,
                subtree: true,
            },
            this.repository
        );
    }
}
